import { useNavigate } from "react-router-dom";
import Nav from './Nav';

function Footer() {
  return (  
    <footer style={{ backgroundColor: '#000', padding: '20px 0' }}>

      <Nav></Nav>
      <div style={{ backgroundColor: '#000', width: '100%', textAlign: 'center', color: '#fff' }}>&copy; { new Date().getFullYear() }  Jasper Quartz Guitar Academy</div>
  </footer>
  );
}

export default Footer;
